import {
	AuthGetterTypes,
	InventoryFormRetainedValuesGetters,
	InventoryFormFormGetters,
} from '../../store/getters';
import { InventoryFormRetainedValuesActions } from '../../store/actions';
import { mapGetters } from 'vuex';
import gridViewFieldsUtils from '../../utils/gridViewFieldsUtils';

export default {
	computed: {
		...mapGetters({
			currentUserId: [AuthGetterTypes.CURRENT_USER_ID],
			retainedValues: [
				InventoryFormRetainedValuesGetters.RETAINED_VALUES,
			],
			form: [InventoryFormFormGetters.SELECTED_INVENTORY_FORM],
		}),

		canRetainValue() {
			if (!this.formField) return false;
			return this.formField.AllowUserToRetainValue;
		},

		hasRetainedValue() {
			if (!this.form) return false;
			if (!this.canRetainValue) return false;
			if (!this.retainedValues) return false;

			let retainedValue = this.retainedValues.find(
				(x) =>
					x.userId === this.currentUserId &&
					x.inventoryFormId === this.form.Id &&
					x.formFieldId == this.formField.Id
			);
			if (retainedValue) return true;
			return false;
		},

		retainedValue() {
			if (!this.hasRetainedValue) return null;
			let retainedValue = this.retainedValues.find(
				(x) =>
					x.userId === this.currentUserId &&
					x.inventoryFormId === this.form.Id &&
					x.formFieldId == this.formField.Id
			);
			return retainedValue.value;
		},
	},
	methods: {
		updateRetainedValue() {
			let values = [];
			this.formField.GridViewFields.forEach((gvf) => {
				let key = gridViewFieldsUtils.getFieldName(gvf);
				values.push({ key: key, value: this.record[key] || '' });
			});
			this.$store.dispatch(InventoryFormRetainedValuesActions.UPDATE, {
				userId: this.currentUserId,
				inventoryFormId: this.form.Id,
				formFieldId: this.formField.Id,
				value: values || [],
			});
		},

		onPinClick() {
			if (this.hasRetainedValue) {
				this.$store.dispatch(
					InventoryFormRetainedValuesActions.REMOVE,
					{
						userId: this.currentUserId,
						inventoryFormId: this.form.Id,
						formFieldId: this.formField.Id,
					}
				);
			} else {
				let values = this.setValues();
				this.$store.dispatch(InventoryFormRetainedValuesActions.ADD, {
					userId: this.currentUserId,
					inventoryFormId: this.form.Id,
					formFieldId: this.formField.Id,
					value: values || [],
				});
			}
		},
		setValues() {
			let values = [];
			let separator = this.formField.Separator || null;
			this.formField.GridViewFields.forEach((gvf, index) => {
				let key = gridViewFieldsUtils.getFieldName(gvf);
				if (separator) {
					values.push({
						key: key,
						value:
							this.selectedValue != undefined &&
							this.selectedValue != null
								? this.selectedValue.split(separator)[index]
								: '',
					});
				} else {
					values.push({ key: key, value: this.selectedValue || '' });
				}
			});
			return values;
		},
	},
};
